import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { ToggleButtonComponent } from "../../../../shared/components/toggle-button/toggle-button.component";
import { CommonModule } from '@angular/common';
import { MembershipType, PaymentPlan } from '../../../../core/interfaces/payment-interfaces';
import { PaymentPlanComponent } from "../../components/payment-plan/payment-plan.component";
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";
import { PaymentService } from '../../../../core/api/payment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { PaymentDialogComponent } from "../../../../shared/dialogs/payment-dialog/payment-dialog.component";
import { InvoiceStatusComponent } from "../../../invoice/components/invoice-status/invoice-status.component";

@Component({
  selector: 'app-settings-plans-page',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, TabButtonComponent, MobileTopbarComponent, TranslocoPipe, ToggleButtonComponent, CommonModule, PaymentPlanComponent, CustomFooterComponent, ToastComponent, PaymentDialogComponent, InvoiceStatusComponent],
  templateUrl: './settings-plans-page.component.html',
  styleUrl: './settings-plans-page.component.css'
})
export class SettingsPlansPageComponent implements OnInit {
  selectedSidebarItemId: number = 13;
  billedYearly: boolean = true;

  // List of payment plans
  listOfPaymentPlans: PaymentPlan[] = [];

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Dialogs
  @ViewChild(PaymentDialogComponent) paymentDialog!: PaymentDialogComponent;

  constructor(private paymentService: PaymentService, private apiError: ApiErrorService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadPaymentPlans();
    this.cd.detectChanges();
  }

  loadPaymentPlans() {
    this.paymentService.getPaymentPlans().subscribe({
      next: (response) => {
        if (response) {
          this.listOfPaymentPlans = response;

          // Sort them in proper order
          const order: Record<any, number> = {
            [MembershipType.START]: 1,
            [MembershipType.SMART]: 2,
          };

          this.listOfPaymentPlans.sort(
            (a, b) => order[a.membership_type] - order[b.membership_type]
          );
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  onPlanSelected(paymentPlan: PaymentPlan): void {
    this.paymentDialog.openModal(paymentPlan, this.billedYearly);
  }
}
